import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95467d72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-assessment-content" }
const _hoisted_2 = {
  key: 0,
  class: "tw-pt-0 tw-flex tw-flex-col"
}
const _hoisted_3 = { class: "tw-px-[40px] tw-py-[25px] tw-flex tw-items-center tw-text-[#211F58] tw-bg-[#F2F8FF]" }
const _hoisted_4 = { class: "tw-w-full" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-5 tw-self-center" }
const _hoisted_7 = { class: "tw-mb-0 tw-text-[16px] tw-leading-[130%] tw-font-semibold" }
const _hoisted_8 = { class: "col-sm-7" }
const _hoisted_9 = { class: "checklist-name" }
const _hoisted_10 = {
  key: 0,
  class: "tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]"
}
const _hoisted_11 = { class: "tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px] tw-bg-[#F2F8FF]" }
const _hoisted_12 = { class: "tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58] tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_13 = { class: "tw-text-[16px] tw-leading-[130%] tw-font-semibold" }
const _hoisted_14 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]" }
const _hoisted_15 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-2" }
const _hoisted_16 = { class: "input-container email-container tw-flex" }
const _hoisted_17 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_19 = { class: "recipient-container tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58] tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_20 = { class: "tw-relative tw-w-full" }
const _hoisted_21 = { class: "tw-text-[16px] tw-leading-[130%] tw-font-semibold" }
const _hoisted_22 = { class: "tw-pr-[20px] tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-text-white tw-text-base tw-font-medium" }, "+", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-2" }
const _hoisted_26 = { class: "information tw-font-[13px] tw-mr-12" }
const _hoisted_27 = { class: "name-value tw-text-[#211f58] tw-text-[13px] tw-font-medium" }
const _hoisted_28 = { class: "information-container tw-flex tw-items-center" }
const _hoisted_29 = { class: "tw-text-[#231F20] tw-text-[13px] tw-mb-0" }
const _hoisted_30 = { class: "tw-text-[#231F20] tw-text-[13px] tw-mb-0" }
const _hoisted_31 = { class: "copy-secret" }
const _hoisted_32 = { class: "tw-flex tw-items-center tw-justify-center" }
const _hoisted_33 = { class: "tw-px-[40px] tw-pb-[40px]" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "tw-flex tw-gap-[10px] tw-items-center tw-justify-end" }

import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, onUnmounted, Ref, ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import store from "@/store";
import BaseDropDown from "../common/form/baseDropDown.vue";
import BaseInput from "../common/form/baseInput.vue";
import RecipientsDetails from "./recipientDetails.vue";
import type RecipientsDetailsType from "./recipientDetails.vue";
import AssessmentDetailsVendorAssessmentModal from "./assessmentDetailsVendorAssessmentModal.vue";
import CreateNewVendorAssessmentCompleteSection from "./createNewVendorAssessmentCompleteSection.vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {
  deleteChecklistRequestedEmailGrant,
  getRequestedDetailItem,
  getVendorProviders,
  postChecklistResendVendor,
} from "@/services/vendor";
import { IVendorProvider } from "@/interfaces/vendor";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import {
  OPTION_EXPIRY_DATE_VENDOR,
  successStatusCodes,
} from "@/utils/constants";
import { Vendor } from "../../services/apiRoutes/routes";
import {
  showError,
  showErrorAPI,
  showSuccessToast,
} from "@/services/apiRoutes";
import get from "lodash/get";
import CustomTable from "../common/customTable.vue";
import CopyInfo from "@/components/common/copyInfo.vue";
import PopoverAssessment from "../assessment/popoverAssessment.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import CustomDropDownItem from "../common/customDropDownItem.vue";

const addANewVendor = "addANewVendor";

interface Option {
  id: number;
  text: string;
  arrowRed: boolean;
  action: (item: any) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'editVendorAssessmentModal',
  props: {
  title: {
    type: String,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 65,
  },
  templateId: {
    type: Number,
    required: false,
    default: 0,
  },
  subTitle: {
    type: String,
    required: false,
    default: "",
  },
  providerId: {
    type: String,
    required: false,
    default: null,
  },
  isShowWarning: {
    type: Boolean,
    required: false,
    default: false,
  },
  checklistRequestedName: {
    type: String,
    required: false,
    default: "",
  },
  dataEmailGrants: {
    type: Array,
    required: false,
    default: () => [],
  },
  dataItem: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  isReviewPage: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:show", "update:data", "update:close"],
  setup(__props, { emit }) {

const props = __props;

const pageModal = {
  page1: 1,
  page2: 2,
  page3: 3,
};


let showRef = ref(props.show);
const recipientsDetailsRef = ref<InstanceType<
  typeof RecipientsDetailsType
> | null>(null);
const assessmentTemplateValueRef = ref(props.templateId);
const vendorDetailsRef = ref<InstanceType<typeof RecipientsDetailsType> | null>(
  null,
);
const currentOrgSecretRequired = computed(
  () => store.state.Org.currentOrgSecretRequired,
);
const vendorValueRef = ref(props.providerId ?? null);
const templateSelection = ref();
const isPage = ref(pageModal.page1);
const isRequiredRecipientDetails = ref(false);
const updateData = ref(false);
const isLoadingAPI = ref(false);
const showRecipientDetailsWarning = ref(false);
const vendorDetailsModal = ref({
  companyName: "",
  description: "",
});
const recipientsDetailsModal = ref({
  name: "",
  email: "",
  expiryDate: "",
  expiryDateOption: OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK,
});
const assessmentDetailsModal = ref({
  descInternal:
    props.dataItem.descInternal || props.dataItem.descriptionInternal,
  notesInternal: props.dataItem.notesInternal,
  descExternal:
    props.dataItem.descExternal || props.dataItem.descriptionExternal,
  notesExternal: props.dataItem.notesExternal,
});
const isAddRecipient: Ref<boolean> = ref(false);
const dataRecipient: Ref<any> = ref(props.dataEmailGrants);
const selectVendorData: Ref<IVendorProvider[]> = ref([]);
const isChangeDesNote: Ref<boolean> = ref(false);
const selectedRecipinentId: Ref<string> = ref("");
const isEditRecipinent: Ref<boolean> = ref(false);
const selectedRecipinentData: Ref<any> = ref("");
const popoverAssessmentHeaderRef: Ref = ref(false);
let animationWidth = ref(0);
const innerTextNextBtnRef: Ref = ref(null);

let dataFormModal;

const screenWidth = ref(window.innerWidth);

const updateWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWidth);
  initial();
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

const initial = async () => {
  fetchVendorSelectData();
};

const fetchVendorSelectData = async () => {
  const providers = await getVendorProviders();
  selectVendorData.value = providers.concat([
    {
      id: addANewVendor,
      name: getComponentUiText(
        "app-vendor-create-assessment-new-a-assessment-option-dropdown-1",
      ),
      color: "#387DFF",
    },
  ]);
};

const subMenuOptions: Ref<Option[]> = ref([
  {
    id: 1,
    text: "app-assess-assessment-modal-edit-meatball-resend-1",
    arrowRed: false,
    action: (data) => handleResendRecipient(data),
  },
  {
    id: 2,
    text: "app-assess-assessment-modal-edit-meatball-edit-1",
    arrowRed: false,
    action: (item) => handleEditRecipient(item),
  },
  {
    id: 3,
    text: "app-assess-assessment-modal-edit-delete-edit-1",
    arrowRed: true,
    action: (item) => handleDeleteRecipient(item),
  },
]);

watch(
  [
    vendorDetailsModal,
    assessmentDetailsModal,
    assessmentTemplateValueRef,
    vendorValueRef,
  ],
  (value) => {
    const object = {
      assessmentTemplateValueRef: assessmentTemplateValueRef.value,
      vendorValueRef: vendorValueRef.value,
      ...vendorDetailsModal.value,
      ...assessmentDetailsModal.value,
    };
    if (
      value[1].descInternal !== props.dataItem.descInternal ||
      value[1].notesInternal !== props.dataItem.notesInternal ||
      value[1].descExternal !== props.dataItem.descExternal ||
      value[1].notesExternal !== props.dataItem.notesExternal
    ) {
      isChangeDesNote.value = true;
    } else {
      isChangeDesNote.value = false;
    }
    if (dataFormModal) {
      updateData.value = Object.keys(object).some(
        (key) => object[key] !== dataFormModal[key],
      );
    }
  },
  { deep: true },
);

const secret = computed(() => store.state.Vendor.secret);

const requestedChecklistProviderIds = computed(() => {
  const requestedChecklist = store.state.Vendor.requestedChecklist;
  return requestedChecklist.map((i) => i.providerId);
});

const rules = {
  vendorSelect: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const formModel = ref({
  vendorSelect: vendorValueRef.value,
});
const $v = useVuelidate(rules, formModel as any);
const tableFields = [
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-edit-table-header-name-1",
    ),
    value: "firstName",
    headerClass:
      "tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-pl-[3px]",
    sortable: false,
    valueClass: "tw-w-[200px] !tw-pr-[16px] !tw-py-[15px] !tw-pl-[3px]",
    font13: true,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-edit-table-header-email-1",
    ),
    value: "recipientEmail",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase  tw-w-[200px]",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[12px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    font13: true,
    valueClass:
      "tw-w-[300px] !tw-text-[#231F20] !tw-text-[12px] !tw-pr-[16px] !tw-py-[15px]",
    textAlign: false,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-edit-table-header-sent-1",
    ),
    value: "dateEmailSent",
    headerClass:
      "tw-text-left tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    valueClass: "tw-w-[150px] !tw-py-[15px]",
    font13: true,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-edit-table-header-expiry-1",
    ),
    value: "validUntil",
    headerClass:
      "tw-text-left tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    font13: true,
    valueClass: "tw-w-[150px] !tw-py-[15px]",
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-edit-table-header-secret-1",
    ),
    value: "secret",
    headerClass:
      "tw-text-left tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    font13: true,
    valueClass: "tw-w-[20px] !tw-pr-[16px] !tw-py-[15px]",
    textAlign: true,
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "!tw-pr-[25px] !tw-py-[15px]",
  },
];
watch(
  () => vendorValueRef.value,
  (value) => {
    if (value) {
      formModel.value.vendorSelect = value;
    }
  },
);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);



const handleCloseModal = (fromModal = false) => {
  if (fromModal && templateSelection.value) return;
  showRef.value = false;
  if (isPage.value === pageModal.page3) {
    emit("update:data");
  }
  emit("update:show", showRef.value);
};

const putChecklistRequested = async () => {
  isLoadingAPI.value = true;

  const params = {
    checklistRequestedDescInternal: assessmentDetailsModal.value.descInternal,
    checklistRequestedDescExternal: assessmentDetailsModal.value.descExternal,
    checklistRequestedNotesInternal: assessmentDetailsModal.value.notesInternal,
    checklistRequestedNotesExternal: assessmentDetailsModal.value.notesExternal,
  };
  try {
    await store.dispatch("Vendor/updateChecklistRequested", {
      params,
      checklistRequestedId: props.dataItem.checklistRequestedId,
    });
    dataFormModal = {
      assessmentTemplateValueRef: assessmentTemplateValueRef.value,
      vendorValueRef: vendorValueRef.value,
      ...vendorDetailsModal.value,
      ...assessmentDetailsModal.value,
    };
    updateData.value = false;
  } catch (error) {
    isLoadingAPI.value = false;
    throw Error;
  }
};

const postChecklistRequestedGetSecret = async () => {
  isLoadingAPI.value = true;

  try {
    const recipientName = recipientsDetailsModal.value.name.split(" ");
    const recipientFirstName = recipientName[0];
    const recipientLastName = recipientName.slice(1).join(" ");
    await store.dispatch("Vendor/postChecklistRequestedGetSecret", {
      payload: {
        checklistRequestedId: props.dataItem.checklistRequestedId,
        recipientEmail: recipientsDetailsModal.value.email,
        recipientFirstName,
        recipientLastName,
        offererOrgName: recipientsDetailsModal.value.name,
        validUntil: recipientsDetailsModal.value.expiryDate,
      },
    });
  } catch (error) {
    throw Error;
  } finally {
    isLoadingAPI.value = false;
  }
};

const handleNext = async () => {
  switch (isPage.value) {
    case pageModal.page1: {
      if (innerTextNextBtnRef.value) {
        animationWidth.value =
          innerTextNextBtnRef.value.getBoundingClientRect()["width"] as number;
      }
      const validate = await recipientsDetailsRef.value?.isCheckValid();
      if ((isAddRecipient.value || isEditRecipinent.value) && !validate) {
        isRequiredRecipientDetails.value = true;
        return;
      }
      const firstName = selectedRecipinentData.value.firstName;
      const lastName = !selectedRecipinentData.value.lastName
        ? ""
        : selectedRecipinentData.value.lastName;
      const selectedData = {
        recipientEmail: selectedRecipinentData.value.recipientEmail,
        recipientName: firstName + " " + lastName,
        recipientExpiryDate: selectedRecipinentData.value.validUntil,
      };
      // check if any data is changed will update the data
      if (
        selectedRecipinentData.value.emailGrantId &&
        (recipientsDetailsModal.value.email !== selectedData.recipientEmail ||
          recipientsDetailsModal.value.name !== selectedData.recipientName ||
          recipientsDetailsModal.value.expiryDate !==
            selectedData.recipientExpiryDate)
      ) {
        const recipientName = recipientsDetailsModal.value.name.split(" ");
        const recipientFirstName = recipientName[0];
        const recipientLastName = recipientName.slice(1).join(" ");
        const params = {
          checklistRequestedId:
            selectedRecipinentData.value.checklistRequestedId,
          emailGrantId: selectedRecipinentData.value.emailGrantId,
        };
        const body = {
          recipientEmail: recipientsDetailsModal.value.email,
          validUntil: recipientsDetailsModal.value.expiryDate,
          recipientFirstName,
          recipientLastName,
        };
        isLoadingAPI.value = true;
        await store.dispatch("Vendor/updateChecklistRequestedEmailGrant", {
          params,
          body,
        });
        showSuccessToast(
          getComponentUiText("app-assess-toast-assessment-update-success-1"),
        );
        emit("update:data");
        selectedRecipinentId.value = "";
        isEditRecipinent.value = false;
        dataRecipient.value = dataRecipient.value.map((item) => {
          if (item.emailGrantId === selectedRecipinentData.value.emailGrantId) {
            return {
              ...item,
              recipientEmail: recipientsDetailsModal.value.email,
              validUntil: recipientsDetailsModal.value.expiryDate,
              firstName: recipientFirstName,
              lastName: recipientLastName,
            };
          }
          return item;
        });
        selectedRecipinentData.value = {};
        recipientsDetailsModal.value.name = "";
        recipientsDetailsModal.value.email = "";
        recipientsDetailsModal.value.expiryDate = "";
      }
      isPage.value = isPage.value + 1;
      isLoadingAPI.value = false;
      break;
    }
    case pageModal.page2: {
      isLoadingAPI.value = true;
      if (innerTextNextBtnRef.value) {
        animationWidth.value =
          innerTextNextBtnRef.value.getBoundingClientRect()["width"] as number;
      }
      try {
        if (isChangeDesNote.value && !isAddRecipient.value) {
          await putChecklistRequested();
          showSuccessToast(
            getComponentUiText("app-assess-toast-assessment-update-success-1"),
          );
          handleCloseModal();
          emit("update:data");
        }
        if (isAddRecipient.value && !isChangeDesNote.value) {
          await postChecklistRequestedGetSecret();
        }
        if (isAddRecipient.value && isChangeDesNote.value) {
          await Promise.all([
            putChecklistRequested(),
            postChecklistRequestedGetSecret(),
          ]);
        }
        if (
          currentOrgSecretRequired.value &&
          currentOrgSecretRequired.value.secretRequiredChecklistRequested &&
          isAddRecipient.value
        ) {
          isPage.value = isPage.value + 1;
        } else {
          handleCloseModal();
          if (isAddRecipient.value || isChangeDesNote.value) {
            emit("update:data");
          }
        }
        if (
          !props.isReviewPage &&
          (isAddRecipient.value || isChangeDesNote.value)
        ) {
          store.dispatch("Vendor/fetchRequestedChecklist", {
            isArchived: false,
          });
        }
      } catch (error) {
        console.error("Error in handleNext:", error);
        isPage.value = pageModal.page2;
      } finally {
        isLoadingAPI.value = false;
      }
      break;
    }
    case pageModal.page3: {
      handleCloseModal();
      emit("update:data");
      break;
    }
    default:
      break;
  }
};

const handlePrevious = () => {
  setTimeout(() => {
    isPage.value = isPage.value - 1;
  }, 10);
};

const handlePrePopulateRecipientDetails = async () => {
  // Clear data before populate.
  showRecipientDetailsWarning.value = false;
  recipientsDetailsModal.value.email = "";
  recipientsDetailsModal.value.name = "";

  if (
    !vendorValueRef.value ||
    !requestedChecklistProviderIds.value.includes(vendorValueRef.value)
  )
    return;

  // Only Provider has Checklist Requested.
  const checklistData = store.state.Vendor.requestedChecklist;
  const checklist = checklistData.find(
    (item) => item.providerId === vendorValueRef.value,
  );

  if (!checklist) return;

  try {
    isLoadingAPI.value = true;
    const res = await getRequestedDetailItem(checklist.checklistRequestedId);
    const emailGrant = get(
      res,
      "data.data.checklistsRequested[0].checklistRequestedEmailGrants[0]",
      {},
    );

    emailGrant.recipientEmail &&
      (recipientsDetailsModal.value.email = emailGrant.recipientEmail || "");

    (emailGrant.firstName || emailGrant.lastName) &&
      (recipientsDetailsModal.value.name = `${emailGrant.firstName || ""} ${
        emailGrant.lastName || ""
      }`);

    const isPopulate =
      recipientsDetailsModal.value.email || recipientsDetailsModal.value.name;

    isPopulate.length && (showRecipientDetailsWarning.value = true);
  } catch (error) {
    showErrorAPI(error, Vendor.getRequestedDetailItem);
  } finally {
    isLoadingAPI.value = false;
  }
};

const styleClassContain = computed(() => ({
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow:
    (screenWidth.value >= 768 || assessmentTemplateValueRef.value) &&
    !vendorValueRef.value
      ? "unset !important"
      : "auto",
}));

const openAddRecipientDetail = () => {
  isAddRecipient.value = true;
  isEditRecipinent.value = false;
  selectedRecipinentId.value = "";
  selectedRecipinentData.value = "";
  recipientsDetailsModal.value.name = "";
  recipientsDetailsModal.value.email = "";
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 7);
  recipientsDetailsModal.value.expiryDate = date.toISOString();
  recipientsDetailsModal.value.expiryDateOption =
    OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK;
};
const handleResendRecipient = async (data) => {
  try {
    const res = await postChecklistResendVendor(
      data.checklistRequestedId,
      data.emailGrantId,
    );
    if (res.status === successStatusCodes.OK) {
      showToastSuccess(
        getComponentUiText(
          "app-component-vendor-assessment-review-modal-resend-vendor-success-message-1",
        ),
      );
    } else {
      showError(
        getComponentUiText(
          "app-component-vendor-assessment-review-modal-resend-vendor-error-message-1",
        ),
      );
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedDetailItem);
  } finally {
    EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  }
};

const handleEditRecipient = (data) => {
  selectedRecipinentId.value = data.emailGrantId;
  isEditRecipinent.value = true;
  isAddRecipient.value = false;
  selectedRecipinentData.value = data;
  const lastName = !data.lastName ? "" : data.lastName;
  const firstName = !data.firstName ? "" : data.firstName;
  recipientsDetailsModal.value.name = firstName + " " + lastName;
  recipientsDetailsModal.value.email = data.recipientEmail;
  recipientsDetailsModal.value.expiryDate = data.validUntil;
  recipientsDetailsModal.value.expiryDateOption =
    OPTION_EXPIRY_DATE_VENDOR.CUSTOM;
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleDeleteRecipient = async (data) => {
  try {
    const res = await deleteChecklistRequestedEmailGrant(
      {
        checklistRequestedId: data.checklistRequestedId,
        emailGrantId: data.emailGrantId,
      },
      {
        isArchived: true,
      },
    );
    if (res.status === successStatusCodes.OK) {
      dataRecipient.value = dataRecipient.value.filter(
        (item) => item.emailGrantId !== data.emailGrantId,
      );
      emit("update:data");
      showToastSuccess(
        getComponentUiText(
          "app-component-vendor-assessment-review-modal-delete-success-message-1",
        ),
      );
    } else {
      showError(
        getComponentUiText(
          "app-component-vendor-assessment-review-modal-resend-vendor-error-message-1",
        ),
      );
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedEmailGrant);
  } finally {
    EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  }
};

const showToastSuccess = (message) => {
  const emitData: IToastMessage = { variant: ToastVariant.SUCCESS, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: () => handleCloseModal(true),
    "max-width": __props.maxWidth,
    "style-class-contain": styleClassContain.value,
    "modal-class": _unref(showRef) ? 'date-picker-modal' : '',
    "height-modal": `${
      vendorValueRef.value === addANewVendor ? '100vh - 150px' : '100vh'
    }`,
    "class-name": `modal-edit-assessment`
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        style: {"z-index":"10"},
        title: 
        _unref(getComponentUiText)(
          'app-component-assessment-edit-assessment-modal-title-1',
        )
      ,
        "sub-title": __props.subTitle,
        onClose: handleCloseModal
      }, null, 8, ["title", "sub-title"]),
      _createElementVNode("div", _hoisted_1, [
        (isPage.value === pageModal.page1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                      "app-vendor-edit-assessments-checklist-name-1",
                    )), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(__props.checklistRequestedName), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              (__props.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(__props.title), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-vendor-assessment-update-title-1")) + " ", 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(getComponentUiText)(
                  "app-vendor-edit-assessments-new-a-assessment-description-select-vendor-1",
                )), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(BaseInput, {
                    id: "name",
                    modelValue: vendorValueRef.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vendorValueRef).value = $event)),
                    container: 'tw-w-full select-vendor-edit-assessment',
                    "class-name": '!tw-items-center !tw-mt-[0px]',
                    "class-name-label": `tw-text-[#231F20]`,
                    label: 
                _unref(getComponentUiText)('app-vendor-assessment-update-title-1')
              ,
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(BaseDropDown, {
                            id: 'vendor-select',
                            modelValue: vendorValueRef.value,
                            "onUpdate:modelValue": [
                              _cache[0] || (_cache[0] = ($event: any) => ((vendorValueRef).value = $event)),
                              _cache[1] || (_cache[1] = 
                      (value) => {
                        vendorValueRef.value = value;
                        handlePrePopulateRecipientDetails();
                      }
                    )
                            ],
                            validation: _unref($v).vendorSelect,
                            data: selectVendorData.value as IDropDownData[],
                            "class-name": 'gray-dropdown-container tw-h-[58px] tw-font-medium',
                            placeholder: 
                      _unref(getComponentUiText)('app-prospect-questions-select-text-1')
                    ,
                            "custom-select-container": 'tw-text-[13px] tw-font-normal tw-leading-[15px]',
                            "text-option-button-dropdown": 
                      _unref(getComponentUiText)(
                        'app-vendor-create-assessment-new-a-assessment-option-dropdown-1',
                      )
                    
                          }, {
                            feedback: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }, 8, ["modelValue", "validation", "data", "placeholder", "text-option-button-dropdown"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-edit-assessment-modal-recipients-1",
                )) + " ", 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessment-edit-assessment-modal-recipients-des-1",
                  )), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "button-add-new-recipients",
                    onClick: openAddRecipientDetail
                  }, _hoisted_24)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(CustomTable, {
                    columns: tableFields,
                    data: dataRecipient.value,
                    "height-tb": true,
                    "custom-class": `recipents-table`,
                    "empty-text": 
                _unref(getComponentUiText)(
                  'app-component-assessments-recipient-table-empty-1',
                )
              
                  }, {
                    "cell(firstName)": _withCtx((data) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(data.item.firstName) + " " + _toDisplayString(" ") + " " + _toDisplayString(data.item.lastName), 1)
                        ])
                      ])
                    ]),
                    "cell(recipientEmail)": _withCtx((data) => [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(data.value), 1)
                    ]),
                    "cell(dateEmailSent)": _withCtx((data) => [
                      _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(convertUTCTimeToLocalTime)(data.value)), 1)
                    ]),
                    "cell(validUntil)": _withCtx((data) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(convertUTCTimeToLocalTime)(data.value)), 1)
                      ])
                    ]),
                    "cell(secret)": _withCtx((data) => [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(CopyInfo, {
                          class: "tw-bg-[#FFFFFF] tw-rounded-md !tw-ml-[15px]",
                          text: data.value,
                          "style-icon-css": 'tw-w-[18px] tw-h-[18px]'
                        }, null, 8, ["text"])
                      ])
                    ]),
                    "cell(action)": _withCtx((data) => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(PopoverAssessment, {
                          ref_key: "popoverAssessmentHeaderRef",
                          ref: popoverAssessmentHeaderRef,
                          class: "tw-h-[56px]",
                          offset: 0,
                          "id-popover": `popover-edit-verdor-assessment-card-${data.item.emailGrantId}`,
                          "style-button": "tw-items-center tw-justify-center"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subMenuOptions.value, (item) => {
                              return (_openBlock(), _createBlock(CustomDropDownItem, {
                                key: `option_edit_vendor_assessment_${item.id}`,
                                "id-text": `${item.text}`,
                                "custom-text-class": `tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                        item.arrowRed ? 'tw-text-[#F7553C]' : ''
                      } tw-whitespace-normal`,
                                "arrow-icon-style": `${
                        item.arrowRed
                          ? 'tw-text-[#F7553C]'
                          : 'tw-text-[#387DFF]'
                      } tw-min-w-[7px]`,
                                padding: 'tw-px-[13px] tw-py-[12px]',
                                "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                                onClick: () => item.action(data.item)
                              }, null, 8, ["id-text", "custom-text-class", "arrow-icon-style", "onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["id-popover"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])
                ])
              ]),
              (isAddRecipient.value || isEditRecipinent.value)
                ? (_openBlock(), _createBlock(RecipientsDetails, {
                    key: 1,
                    ref_key: "recipientsDetailsRef",
                    ref: recipientsDetailsRef,
                    modelValue: recipientsDetailsModal.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((recipientsDetailsModal).value = $event)),
                    "show-warning": showRecipientDetailsWarning.value,
                    "onUpdate:isDisabled": _cache[4] || (_cache[4] = (val) => (isRequiredRecipientDetails.value = val))
                  }, null, 8, ["modelValue", "show-warning"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (isPage.value === pageModal.page2)
          ? (_openBlock(), _createBlock(AssessmentDetailsVendorAssessmentModal, {
              key: 1,
              modelValue: assessmentDetailsModal.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((assessmentDetailsModal).value = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (isPage.value === pageModal.page3)
          ? (_openBlock(), _createBlock(CreateNewVendorAssessmentCompleteSection, {
              key: 2,
              secret: secret.value
            }, null, 8, ["secret"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "tw-bg-[#fff] hover:!tw-bg-[#F7553C] hover:tw-text-[#fff] tw-text-[#F7553C] tw-border-[2px] tw-border-solid tw-border-[#F7553C] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-w-fit tw-h-[39px] tw-leading-[100%] tw-font-medium tw-flex tw-items-center tw-justify-center",
                onClick: _cache[6] || (_cache[6] = () => handleCloseModal())
              }, _toDisplayString(_unref(getComponentUiText)(
                  "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
                )), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                (isPage.value !== pageModal.page1 && isPage.value !== pageModal.page3)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "tw-flex tw-items-center tw-bg-[#FFF] tw-text-[#387DFF] tw-border-2 tw-border-solid tw-border-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium",
                      onClick: handlePrevious
                    }, _toDisplayString(_unref(getComponentUiText)(
                    "app-modal-edit--vendor-assessment-btn-previous-1",
                  )), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass(["tw-flex tw-items-center tw-bg-[#DBDBDB] tw-text-[#B7B7B7] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium", `${'!tw-bg-[#387DFF] tw-text-white hover:!tw-bg-[#0069d9]'}`]),
                  onClick: handleNext
                }, [
                  (!isLoadingAPI.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        ref_key: "innerTextNextBtnRef",
                        ref: innerTextNextBtnRef
                      }, _toDisplayString(_unref(getComponentUiText)(
                      isPage.value === pageModal.page3 ||
                        (isPage.value === pageModal.page2 &&
                          (!currentOrgSecretRequired.value.secretRequiredChecklistRequested ||
                            !isAddRecipient.value))
                        ? "app-modal-edit--vendor-assessment-btn-completed-1"
                        : "app-modal-edit--vendor-assessment-btn-next-1",
                    )), 513))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle({ width: _unref(animationWidth) + 'px' }),
                        class: "tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
                      }, [
                        _createVNode(_unref(LottieAnimation), {
                          ref: "anim",
                          "animation-data": _unref(ProgressAnimation),
                          "auto-play": true,
                          loop: true
                        }, null, 8, ["animation-data"])
                      ], 4))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "close", "max-width", "style-class-contain", "modal-class", "height-modal"]))
}
}

})